module.exports = {
    'ADD_DIRECTOR_INTENT': 'add_director_intent',
    'REMOVE_DIRECTOR_INTENT': 'remove_director_intent',
    'CHANGE_FINANCIAL_YEAR_END': 'change_financial_year_end_intent',
    'ISSUE_SHARES': 'issue_shares_intent',
    'TRANSFER_SHARES': 'transfer_shares_intent', 
    'OTHERS_INTENT': 'others_intent'
};